// extracted by mini-css-extract-plugin
export default {"payment-methods-container":"PaymentMethods_payment-methods-container__HFU7f"};